import * as stylex from '@stylexjs/stylex'
import Avatar from '../../components/Avatar'
import Button from '../../components/Button'
import EmptyState from '../../components/EmptyState'
import PageHeader from '../../components/PageHeader'
import Icon from '../../components/Icon'
import { findPerson, formatMoney, groupSpent, type Overview } from '../../lib/ledger'


const styles = stylex.create({
  s0: {
    display: "flex",
    flexDirection: "column",
    rowGap: "28px",
  },
  s1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "16px",
    "@media (min-width: 640px)": {
      flexDirection: "row",
      alignItems: "end",
    },
  },
  s2: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#5b9164",
  },
  s3: {
    marginTop: "4px",
    fontSize: "clamp(1.75rem,3.2vw,2.25rem)",
    fontWeight: 600,
    letterSpacing: "-.045em",
  },
  s4: {
    marginTop: "8px",
    fontSize: "14px",
    color: "#707b72",
  },
  s5: {
    display: "flex",
    height: "40px",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "0.75rem",
    backgroundColor: "#3f8955",
    paddingInline: "16px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#fff",
    boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    transition: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    ":hover": {
      backgroundColor: "#347c49",
    },
  },
  s6: {
    height: "16px",
    width: "16px",
  },
  s7: {
    borderRadius: "1rem",
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: "#cbdcc9",
    backgroundColor: "#fbfdf9",
    paddingInline: "20px",
    paddingBlock: "56px",
    textAlign: "center",
  },
  s8: {
    marginInline: "auto",
    display: "flex",
    height: "48px",
    width: "48px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "1rem",
    backgroundColor: "#e9f4e7",
    color: "#478254",
  },
  s9: {
    height: "24px",
    width: "24px",
  },
  s10: {
    marginTop: "16px",
    fontSize: "17px",
    fontWeight: 600,
  },
  s11: {
    marginInline: "auto",
    marginTop: "8px",
    maxWidth: "24rem",
    fontSize: "13px",
    lineHeight: "1.25rem",
    color: "#727d75",
  },
  s12: {
    marginTop: "20px",
    height: "40px",
    borderRadius: "0.75rem",
    backgroundColor: "#438b57",
    paddingInline: "16px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#fff",
  },
  s13: {
    display: "grid",
    gap: "16px",
    "@media (min-width: 768px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    "@media (min-width: 1280px)": {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
  },
  s14: {
    overflow: "hidden",
    borderRadius: "1rem",
    borderWidth: 1,
    borderColor: "#e0e7de",
    backgroundColor: "#fff",
    boxShadow: "0 4px 16px rgba(48,70,51,.035)",
  },
  s15: {
    padding: "20px",
  },
  s16: {
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    gap: "16px",
  },
  s17: {
    height: "20px",
    width: "20px",
  },
  s18: {
    borderRadius: "0.5rem",
    padding: "6px",
    color: "#879288",
    transition: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    ":hover": {
      backgroundColor: "#f1f5ef",
      color: "#3d7c4d",
    },
  },
  s19: {
    marginTop: "20px",
    fontSize: "17px",
    fontWeight: 600,
    letterSpacing: "-.02em",
  },
  s20: {
    marginTop: "4px",
    minHeight: "40px",
    fontSize: "12px",
    lineHeight: "1.25rem",
    color: "#748077",
  },
  s21: {
    marginTop: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderColor: "#edf0eb",
    paddingTop: "16px",
  },
  s22: {
    display: "flex",
  },
  s23: {
    boxShadow: "0 0 0 1px #fff",
  },
  s24: {
    display: "flex",
    height: "31px",
    width: "31px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "9999px",
    backgroundColor: "#e8eee6",
    fontSize: "10px",
    fontWeight: 600,
    color: "#54705c",
    boxShadow: "0 0 0 1px #fff",
  },
  s25: {
    textAlign: "right",
  },
  s26: {
    fontSize: "10px",
    color: "#879087",
  },
  s27: {
    marginTop: "2px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#3e5944",
  },
  s28: {
    marginTop: "20px",
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "8px",
  },
  s29: {
    height: "40px",
    borderRadius: "0.75rem",
    borderWidth: 1,
    borderColor: "#dce6da",
    fontSize: "12px",
    fontWeight: 600,
    color: "#486c50",
    transition: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    ":hover": {
      backgroundColor: "#f5f9f4",
    },
  },
  s30: {
    display: "flex",
    height: "40px",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "0.75rem",
    backgroundColor: "#eff6ed",
    fontSize: "12px",
    fontWeight: 600,
    color: "#3f7e4d",
    transition: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    ":hover": {
      backgroundColor: "#e5f1e2",
    },
  },
  s31: {
    height: "14px",
    width: "14px",
  },
})

const groupCardStyles = stylex.create({
  stripe: { height: '8px' },
  stripeGreen: { backgroundColor: '#6da17a' },
  stripeTan: { backgroundColor: '#c29c65' },
  stripeBlue: { backgroundColor: '#7e9aa2' },
  icon: { display: 'flex', height: '44px', width: '44px', alignItems: 'center', justifyContent: 'center', borderRadius: '1rem' },
  iconGreen: { backgroundColor: '#eaf5e7', color: '#478155' },
  iconTan: { backgroundColor: '#f8f0e4', color: '#9a7045' },
})
type GroupsPageProps = {
  data: Overview
  onAddExpense: (groupID: string) => void
  onCreateGroup: () => void
  onOpenGroup: (groupID: string) => void
}

export default function GroupsPage({ data, onAddExpense, onCreateGroup, onOpenGroup }: GroupsPageProps) {
  return <div {...stylex.props(styles.s0)}><PageHeader action={<Button onClick={onCreateGroup}><Icon name="plus" />New group</Button>} eyebrow="Shared spaces" subtitle="Keep each trip, home, and regular plan in its own clear place." title="Your groups" />
    {data.groups.length === 0 ? <section {...stylex.props(styles.s7)}><EmptyState action={<Button onClick={onCreateGroup}>Create a group</Button>} description="Create a shared space before adding expenses, so everyone sees the same picture." icon={<Icon name="groups" />} title="Start your first group" /></section> : <section {...stylex.props(styles.s13)}>{data.groups.map((group, index) => { const members = group.memberIds.map((id) => findPerson(data, id)).filter((member) => member !== undefined); const spent = groupSpent(data, group.id); return <article {...stylex.props(styles.s14)} key={group.id}><div {...stylex.props(groupCardStyles.stripe, index % 3 === 0 ? groupCardStyles.stripeGreen : index % 3 === 1 ? groupCardStyles.stripeTan : groupCardStyles.stripeBlue)} /><div {...stylex.props(styles.s15)}><div {...stylex.props(styles.s16)}><span {...stylex.props(groupCardStyles.icon, index % 2 === 0 ? groupCardStyles.iconGreen : groupCardStyles.iconTan)}><Icon {...stylex.props(styles.s17)} name="groups" /></span><button aria-label={`Open ${group.name}`} {...stylex.props(styles.s18)} onClick={() => onOpenGroup(group.id)} type="button"><Icon {...stylex.props(styles.s17)} name="arrow-right" /></button></div><h2 {...stylex.props(styles.s19)}>{group.name}</h2><p {...stylex.props(styles.s20)}>{group.description || 'A place to split expenses together.'}</p><div {...stylex.props(styles.s21)}><div {...stylex.props(styles.s22)}>{members.slice(0, 4).map((member) => member && <Avatar {...stylex.props(styles.s23)} key={member.id} person={member} size={31} />)}{members.length > 4 && <span {...stylex.props(styles.s24)}>+{members.length - 4}</span>}</div><div {...stylex.props(styles.s25)}><p {...stylex.props(styles.s26)}>group spending</p><p {...stylex.props(styles.s27)}>{formatMoney(spent, data.currentUser.currency)}</p></div></div><div {...stylex.props(styles.s28)}><Button onClick={() => onOpenGroup(group.id)} variant="secondary">View group</Button><Button onClick={() => onAddExpense(group.id)}><Icon name="plus" />Expense</Button></div></div></article> })}</section>}
  </div>
}
